<template>
  <div class="flex column" style="width: 100vm" v-title data-title="其他问题">
    <div v-for="(data, index) in list" :key="index">
      <div class="flex column" style="height: 49px; margin: 0 16px" @click="$router.push({name:'QuestionDetail', params: {question: JSON.stringify(data)}})">
        <div class="flex main-space-between cross-center" style="height: 49px;">
          <span>{{index + 1}}.{{data.title}}</span>
          <img src="../assets/arrow_right.png" style="width: 7px; height: 13px">
        </div>
        <div style="background: #EEEEEEFF; height: 1px; width: 100%"></div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "AboutStudentClass",
    data () {
      return{
        list: [
          {
            title: '班级是什么？',
            detailTexts: [{title: '阅伴App中的班级是老师统一管理学生进行阅读学习的线上功能。'}]
          },
          {
            title: '班号是什么？',
            detailTexts: [{title: '班号是阅伴自动分配的数字，是班级的ID，此ID是唯一的。'}]
          },
          {
            title: '如何加入班级？',
            detailTexts: [{title: '在阅伴学生端App找到“班级”菜单后，在搜索框内输入老师提供的班号，然后点击申请加入，老师审核通过后就成功加入班级了。'}]
          },
          {
            title: '班级阅读任务是什么？',
            detailTexts: [{title: '班级阅读任务是老师在班级内发布的阅读作业，学生需要按照任务安排进行阅读，点击任务中的图书即可闯关。'}]
          },
          {
            title: '怎样退出班级？',
            detailTexts: [{title: '进入您想要退出的班级，点击右上角的“设置”，然后点击退出班级即可。'}]
          },
          {
            title: '通过班号搜索不到班级怎么办？',
            detailTexts: [{title: '检查班号是否正确，如果班号确认是正确的，可以联系阅伴客服。'}]
          },
          {
            title: '收不到老师布置的任务怎么办？',
            detailTexts: [{title: '检查是否进入老师创建的班级，如果正确请与自己的老师联系是否布置了阅读任务。'}]
          },
          {
            title: '手机不能获取验证码怎么办？',
            detailTexts: [{title: '阅伴App支持两种登录方式，一是手机号和短信验证码登录，二是手机号和密码的登录方式。如果遇到不方便接收验证码的情况下，可以使用密码登录（所以，一定要记得注册时设置的登录密码）。'}]
          },
          {
            title: '为什么孩子的阅芽总是不够？',
            detailTexts: [{title: '阅芽不足的原因：\n' +
                '读书不认真，导致每一关卡都要多次重复闯关。建议闯关之前先确认准备闯关对应的页码范围，认真阅读相应范围内的内容后立即开始闯关。闯关成功率提高，奖励阅芽数量会越来越多。'},
              {title: '快速获取阅芽：\n' +
                  '①在阅伴书店购书后，提交购书订单号，可以兑换阅芽。 ②购买会员通过签到，可以获得阅芽。 ③成功闯关可以获得阅芽奖励。 ④关注阅伴微信公众号参加阅伴活动。 ⑤老师赠送阅芽。⑥在阅芽农场中兑换阅芽。'}]
          },
          {
            title: '阅伴App为什么不能看书？',
            detailTexts: [{title: '您好，阅伴App目前仅提供闯关功能，如果想读书建议您在阅伴书店购买正版纸质书，购书还可以获得阅芽等奖励。'}]
          },
          {
            title: '为什么找不到自己的学校？',
            detailTexts: [{title: '在阅伴APP中找不到学校，可拨打电话联系阅伴客服添加学校。\n' +
                '联系方式029-89875100'}]
          },
        ]
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/AboutStudentClass.vue